import { supabase } from "../supabase";
import { createNotification } from "./notifications";

// Standalone version of LikeButton's handleLike, for triggering a like from
// somewhere other than the heart button itself (double-tap on the photo).
// likeOnly=true never unlikes — same as Instagram's double-tap gesture.
//
// Goes through the toggle_design_like RPC rather than a client-side
// read-then-write — two likes landing on the same popular design within
// milliseconds of each other used to both read the same starting likes/
// liked_by, then the second UPDATE silently overwrote the first, losing a
// like (or leaving that user's own heart showing the wrong state).
export async function likeDesign({ designId, user, designOwnerId, onUpdate, likeOnly = false }) {
  if (!user) return { error: new Error("not_logged_in") };

  const { data, error } = await supabase
    .rpc("toggle_design_like", { target_design_id: designId, like_only: likeOnly })
    .single();

  if (error) return { error };

  onUpdate?.({ likes: data.like_count, _likedByMe: data.liked });

  if (data.changed && data.liked) {
    createNotification({ userId: designOwnerId, actorId: user.id, type: "like", designId });
  }

  return { error: null, changed: data.changed, liked: data.liked };
}
